import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useServicosProdutosListaFilters
 */

type State = {
  field: number;
  fieldValue: string;
  tipo: number;
  status: number;
};

export const initialServicosProdutosListaFilters: State = {
  field: 1,
  fieldValue: '',
  tipo: 1,
  status: 2,
}

export const useServicosProdutosListaFilters = create<State>((set) => ({
  ...initialServicosProdutosListaFilters,
}));